import { ConfigProvider, Form, Tabs } from 'antd'
import classNames from 'classnames'
import React, { useMemo } from 'react'
import ValueTable from './ValueTable'
import enUS from "antd/locale/en_US";

import classes from './ReservoirSetting.module.scss'

const ReservoirSetting = () => {
  const form = Form.useFormInstance()
  
  const simulationUnit = Form.useWatch(["GENERAL", "unit"])
  const reservoirType = Form.useWatch(['GENERAL', 'reservoir'], form)

  const tabs = useMemo(
    /**
     * @returns {import('antd').TabsProps['items']}
     */
    () => {
      const baseTabs = [
        {
          key: 'matrix',
          label: 'Matrix',
          children: (
              <Form.List name={["RESERVOIR", "matrix"]}>
                {(fields, operation) => (
                  <ValueTable 
                    tab="matrix" 
                    fields={fields} 
                    operation={operation}
                    simulationUnit={simulationUnit}
                    showFractureDensity={reservoirType === 'Dualperm'}
                  />
                )}
              </Form.List>
          )
        }
      ]

      return baseTabs
    }, [simulationUnit, reservoirType])

  return (
    <ConfigProvider
      locale={enUS}
      componentSize="middle"
      theme={{
        token: {},
        components: {},
      }}
    >
      <Tabs 
        type="card" 
        items={tabs} 
        className={classNames(classes.tabs, classes.parentTabs)} 
        destroyInactiveTabPane={false} 
      />
    </ConfigProvider>
  )
}

export default ReservoirSetting